import { render } from "./NetworkCard.vue?vue&type=template&id=35564d78"
import script from "./NetworkCard.vue?vue&type=script&lang=js"
export * from "./NetworkCard.vue?vue&type=script&lang=js"

import "./NetworkCard.vue?vue&type=style&index=0&id=35564d78&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__